export default __webpack_public_path__ + "253061c88116ce95c3f7ac2acea60d31.png";